import { Box, Grid, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerUnknown: {
      backgroundColor: '#eaf9ee',
      color: '#3d9452',
      padding: theme.spacing(2),
    },
    upperHeaderText: {
      fontSize: 10,
      letterSpacing: 1.5,
      fontWeight: 500,
      color: '#3d9452',
    },
    mainHeaderText: {
      fontWeight: 500,
      color: '#3d9452',
    },
    unknownBody: {
      padding: theme.spacing(2),
    },
  }),
);

interface PaymentUnknownProps {
  email?: string | null;
}

const PaymentUnknown: React.FC<PaymentUnknownProps> = props => {
  const classes = useStyles();
  const { email } = props;
  return (
    <Box data-cy="payment-unknown-message">
      <Grid container className={classes.headerUnknown}>
        <Grid item xs={12} lg={12}>
          <Typography variant="body2" className={classes.upperHeaderText}>
            THANK YOU
          </Typography>
        </Grid>
        <Grid item xs={12} lg={12}>
          <Typography className={classes.mainHeaderText}>
            You will receive your payment receipt by email
            <br />
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} className={classes.unknownBody}>
        <Grid item xs={12} lg={12}>
          <Typography variant="body2" paragraph={true}>
            You will receive an email receipt at
            <br />
            <b>{email}</b>
          </Typography>
          <Typography variant="body2">You can safely close this window.</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentUnknown;
